import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './avatar.css';

function Zoneqr() {
  const zoneQRLinks = [
    { url: 'https://aivoice.allkalki.com/zone1.html', title: 'Z1' },
    { url: 'https://aivoice.allkalki.com/zone2.html', title: 'Z2' },
    { url: 'https://aivoice.allkalki.com/zone3.html', title: 'Z3' },
    { url: 'https://aivoice.allkalki.com/zone4.html', title: 'Z4' },
    { url: 'https://aivoice.allkalki.com/zone5.html', title: 'Z5' },
  ];

  return (
    <div className="qr-scroll-container">
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '32px' }}>🎥 Zone QR Codes</h2>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', justifyContent: 'center' }}>
        {zoneQRLinks.map((item, index) => (
          <div key={index} className="qr-item">
            <QRCodeSVG value={item.url} size={128} />
            <p className="qr-title">QR {index + 1}</p>
            <p className="qr-subtitle">{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Zoneqr;